import { useRefresh, List, Datagrid, FunctionField, Identifier, ListControllerResult } from "react-admin"
import Select from "react-select"
import { ENABLE_DISABLE_KOL_PROFILE } from "../queries/kol-profile"
import React, { useEffect, useState, useRef, useCallback, useMemo } from "react"
import { useMutation, DefaultOptions, ApolloClient, InMemoryCache } from "@apollo/client"
import { useRole } from "../hooks/useRole"
import { ReactComponent as SearchIcon } from "../assets/ic_search_kol.svg"
import { AddKolDialog } from "./AddKolDialog"
import { useApolloClient } from "@apollo/client"
import {
  INSERT_KOL,
  DELETE_KOL_SOCIAL_PLATFORM,
  UPDATE_KOL,
  DELETE_KOL_PROFILE,
  INSERT_KOL_SOCIAL_PLATFORMS,
  SEARCH_KOL_BY_NAME,
  GET_KOL_DETAILS,
  GET_KOLS,
  GET_PRODUCT_CATEGORIES,
  GET_SOCIAL_PLATFORMS,
  GET_COUNTRIES,
} from "./queries"
import { v4 as uuid } from "uuid"
import { useNotify } from "react-admin"
import "../App.css"
import { formatNumber } from "./AddKolDialog"
import { ALIST } from "../constants"
import DropdownMenu from "./DropdownMenu"
import { CustomPagination } from "../components/CustomPagination"

interface KolSocialPlatform {
  social_platform_code: string
  social_platform_handle?: string
  number_of_followers?: number | string
  social_platform_tier?: string
}

const malaysiaSubitems = [
  { value: "Johor", label: "Johor" },
  { value: "Kedah", label: "Kedah" },
  { value: "Kelantan", label: "Kelantan" },
  { value: "Kuala Lumpur", label: "Kuala Lumpur" },
  { value: "Melaka", label: "Melaka" },
  { value: "Negeri Sembilan", label: "Negeri Sembilan" },
  { value: "Pahang", label: "Pahang" },
  { value: "Pulau Pinang", label: "Pulau Pinang" },
  { value: "Perak", label: "Perak" },
  { value: "Perlis", label: "Perlis" },
  { value: "Sabah", label: "Sabah" },
  { value: "Sarawak", label: "Sarawak" },
  { value: "Selangor", label: "Selangor" },
  { value: "Terengganu", label: "Terengganu" },
]

// const locationItems = [
//   {
//     value: "malaysia",
//     label: "Malaysia",
//     items: [
//       { value: "Johor", label: "Johor" },
//       { value: "Kedah", label: "Kedah" },
//       { value: "Kelantan", label: "Kelantan" },
//       { value: "Melaka", label: "Melaka" },
//       { value: "Negeri Sembilan", label: "Negeri Sembilan" },
//       { value: "Pahang", label: "Pahang" },
//       { value: "Penang (Pulau Pinang)", label: "Penang (Pulau Pinang)" },
//       { value: "Perak", label: "Perak" },
//       { value: "Perlis", label: "Perlis" },
//       { value: "Sabah", label: "Sabah" },
//       { value: "Sarawak", label: "Sarawak" },
//       { value: "Selangor", label: "Selangor" },
//       { value: "Terengganu", label: "Terengganu" },
//     ],
//   },
//   { value: "singapore", label: "Singapore" },
//   { value: "indonesia", label: "Indonesia" },
//   { value: "hong kong", label: "Hong Kong" },
// ]

const genderItems = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
]

const tierOfKolItems = [
  { value: "a-list", label: "A-list" },
  { value: "elite", label: "Elite" },
  { value: "mega", label: "Mega" },
  { value: "macro", label: "Macro" },
  { value: "mid_b", label: "Mid B" },
  { value: "mid_c", label: "Mid C" },
  { value: "micro", label: "Micro" },
  { value: "nano", label: "Nano" },
  { value: "koc", label: "KOC" },
]

interface SugguestionItem {
  id: any
  name: string
  platforms: any[]
}

interface SugguestionListProps {
  data: SugguestionItem[]
  onItemClick: (item: SugguestionItem) => void
}

const platformNameInAbbrev = (platformCode: string) => {
  switch (platformCode) {
    case "INSTAGRAM":
      return "IG"
    case "TIKTOK":
      return "TT"
    case "YOUTUBE":
      return "YT"
    case "FACEBOOK":
      return "FB"
    case "XIAOHONGSHU":
      return "XHS"
    case "LEMON8":
      return "L8"
    default:
      return platformCode
  }
}

function sugguestionInformation(sugguestion: SugguestionItem) {
  if (
    !sugguestion.platforms ||
    sugguestion.platforms.length == 0 ||
    sugguestion.platforms.every(
      (platform) => !platform.social_platform_handle || `${platform.social_platform_handle}`.trim() === "",
    )
  ) {
    return `${sugguestion.name} (No Social Account)`
  }

  let information = `${sugguestion.name} | `
  for (let i = 0; i < sugguestion.platforms.length; i++) {
    information += `${sugguestion.platforms[i].social_platform_handle} (${platformNameInAbbrev(
      sugguestion.platforms[i].social_platform_code,
    )})`
    if (i < sugguestion.platforms.length - 1) {
      information += " | "
    }
  }
  return information
}

const SugguestionList: React.FC<SugguestionListProps> = ({ data, onItemClick }) => {
  return (
    <div style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
      {data.map((item) => (
        <div
          key={item.id}
          style={{
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "1px",
            paddingBottom: "1px",
            backgroundColor: "white",
            cursor: "pointer",
          }}
          onClick={() => {
            onItemClick(item)
          }}
        >
          <p>{sugguestionInformation(item)}</p>
        </div>
      ))}
    </div>
  )
}

export default SugguestionList

export const KolProfilesList = (props: any) => {
  const refresh = useRefresh()
  const client = useApolloClient()

  const [insertKol] = useMutation(INSERT_KOL)
  const [updateKol] = useMutation(UPDATE_KOL)
  const [deleteKol] = useMutation(DELETE_KOL_PROFILE)

  const [enableDisableKolProfile, enableDisableKolProfileResult] = useMutation<
    any,
    {
      isApproved: boolean
      isActive: boolean
      kolProfileId: string
    }
  >(ENABLE_DISABLE_KOL_PROFILE)

  if (enableDisableKolProfileResult.called && !enableDisableKolProfileResult.loading) {
    refresh()
  }

  const role = useRole()
  const [filter, setFilter] = useState({
    social_platform: "",
    platform_handle: "",
    category: "",
    state: "",
    gender: "",
    tier: "",
    platform: "",
  })

  // Memoize callback functions to prevent re-renders
  const handleLocationChange = useCallback((value: string, label: string) => {
    console.log(`Selected: ${label} (${value})`)
    setFilter((prev) => ({
      ...prev,
      state: value,
    }))
  }, [])

  const handleGenderChange = useCallback((value: string, label: string) => {
    console.log(`Selected: ${label} (${value})`)
    setFilter((prev) => ({
      ...prev,
      gender: value,
    }))
  }, [])

  const handleTierChange = useCallback((value: string, label: string) => {
    console.log(`Selected: ${label} (${value})`)
    setFilter((prev) => ({
      ...prev,
      tier: value,
    }))
  }, [])

  const handlePlatformChange = useCallback((value: string, label: string) => {
    console.log(`Selected: ${label} (${value})`)
    setFilter((prev) => ({
      ...prev,
      platform: value,
    }))
  }, [])

  const handleCategoryChange = useCallback((value: string, label: string) => {
    setFilter((prev) => ({
      ...prev,
      category: value,
    }))
  }, [])

  const [showPopup, setShowPopup] = useState(false)

  const [selectedKol, setSelectedKol] = useState<any>(null)

  const notify = useNotify()

  const onRowClick = (record: any) => {
    setShowPopup(true)
    setSelectedKol(record)
    setSuggestions([])
  }

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      if (showPopup) {
        setShowPopup(false)
        setSelectedKol({})
        event.preventDefault()
      }
    }

    window.addEventListener("popstate", handleBeforeUnload)
    const unlisten = () => {
      window.removeEventListener("popstate", handleBeforeUnload)
    }

    return () => {
      unlisten()
    }
  }, [showPopup])

  const addKolButtonPosition = 10
  const addKolButtonWidth = 100
  const exportButtonWidth = 120
  const searchBarWidth = 300
  const searchBarPosition = addKolButtonPosition + addKolButtonWidth + 10
  const socialPlatformSelectionPosition = searchBarPosition + searchBarWidth + 10
  const categoryDropdownWidth = 180
  const categoryDropdownPosition = searchBarPosition + searchBarWidth + 10
  const actionTopMargin = 50

  const [locationItems, setLocationItems] = useState<
    Array<{ value: string; label: string; items?: Array<{ value: string; label: string }> }>
  >([])

  const suggestionListRef = useRef<HTMLDivElement>(null)
  const handleClickOutsideSugguestion = (event: MouseEvent) => {
    if (suggestionListRef.current && !suggestionListRef.current.contains(event.target as Node)) {
      setSuggestions([])
    }
  }

  useEffect(() => {
    // Force no-cache policy on the client instance
    client.defaultOptions = {
      watchQuery: {
        fetchPolicy: "no-cache",
        errorPolicy: "ignore",
      },
      query: {
        fetchPolicy: "no-cache",
        errorPolicy: "all",
      },
      mutate: {
        fetchPolicy: "no-cache",
        errorPolicy: "all",
      },
    }
  }, [client])
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideSugguestion)
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideSugguestion)
    }
  }, [])
  const [inputValue, setInputValue] = useState("")
  const debouncedInputValue = useDebounce(inputValue, 500)
  const [suggestions, setSuggestions] = useState<SugguestionItem[]>([])

  const groupKolById = (searchKOLByNameResult: any) => {
    const sugguestion = searchKOLByNameResult.data.map((kol: any) => {
      return {
        id: kol.id,
        name: kol.name,
        social_platform_code: kol.social_platform_code,
        social_platform_handle: kol.social_platform_handle,
      }
    })
    const displaySugguestion = Array<SugguestionItem>()
    const processedIds = Array<any>()
    for (let i = 0; i < sugguestion.length; i++) {
      let kol = sugguestion[i]
      if (processedIds.indexOf(kol.id) !== -1) {
        continue
      } else {
        let socialPlatforms = Array<any>()
        for (let j = 0; j < sugguestion.length; j++) {
          if (kol.id === sugguestion[j].id) {
            socialPlatforms.push({
              social_platform_code: sugguestion[j].social_platform_code,
              social_platform_handle: sugguestion[j].social_platform_handle,
            })
          }
        }
        kol.platforms = socialPlatforms
        displaySugguestion.push(kol)
        processedIds.push(kol.id)
      }
    }
    return displaySugguestion
  }

  const fetchSugguestion = (value: string) => {
    client
      .query({
        query: SEARCH_KOL_BY_NAME,
        variables: {
          name: value,
        },
        fetchPolicy: "no-cache",
      })
      .then((result: any) => {
        setSuggestions(groupKolById(result.data.searchKOLByName))
      })
  }
  const getKolDetails = (sugguestion: any) => {
    client
      .query({
        query: GET_KOL_DETAILS,
        variables: {
          id: sugguestion.id,
          name: sugguestion.name,
        },
      })
      .then((result: any) => {
        if (result.data.getKOLDetail) {
          const country =
            countryItems.find((c) => c.value === result.data.getKOLDetail.country_code)?.label ||
            result.data.getKOLDetail.country_code
          const data = { ...result.data.getKOLDetail, country: country }
          onRowClick(data)
        }
      })
  }

  useEffect(() => {
    if (debouncedInputValue) {
      fetchSugguestion(debouncedInputValue)
      const newFilter = {
        social_platform: filter.social_platform,
        platform_handle: debouncedInputValue,
        category: filter.category,
        state: filter.state,
        gender: filter.gender,
        tier: filter.tier,
        platform: filter.platform,
      }
      setFilter(newFilter)
    } else {
      setSuggestions([])
    }
  }, [debouncedInputValue])

  const [categoryItems, setCategoryItems] = useState<Array<{ value: string; label: string }>>([])
  const [platformItems, setPlatformItems] = useState<Array<{ value: string; label: string }>>([])
  const [countryItems, setCountryItems] = useState<Array<{ value: string; label: string }>>([])

  // Memoize items arrays
  const memoizedCategoryItems = useMemo(() => categoryItems, [categoryItems])
  const memoizedPlatformItems = useMemo(() => platformItems, [platformItems])
  const memoizedLocationItems = useMemo(() => locationItems, [locationItems])
  const memoizedGenderItems = useMemo(() => genderItems, [])
  const memoizedTierItems = useMemo(() => tierOfKolItems, [])

  useEffect(() => {
    // Fetch categories from API and convert for DropdownMenu
    const fetchCategories = async () => {
      try {
        const { data } = await client.query({
          query: GET_PRODUCT_CATEGORIES,
          fetchPolicy: "no-cache",
        })

        // Map API data to DropdownMenu format
        const options = data.product_category.map((category: any) => ({
          value: category.name,
          label: category.name,
        }))

        // Add default option
        setCategoryItems([...options])
      } catch (error) {
        console.error("Error fetching categories:", error)
      }
    }

    fetchCategories()
  }, [client])

  useEffect(() => {
    // Fetch platforms from API and convert for DropdownMenu
    const fetchPlatforms = async () => {
      try {
        const { data } = await client.query({
          query: GET_SOCIAL_PLATFORMS,
          fetchPolicy: "no-cache",
        })

        // Map API data to DropdownMenu format
        const options = data.social_platform.map((platform: any) => ({
          value: platform.code,
          label: platform.name,
        }))

        // Set platform items
        setPlatformItems(options)
      } catch (error) {
        console.error("Error fetching platforms:", error)
        // Fallback to static options if API fails
        setPlatformItems([
          { value: "INSTAGRAM", label: "Instagram" },
          { value: "YOUTUBE", label: "YouTube" },
          { value: "TIKTOK", label: "TikTok" },
          { value: "FACEBOOK", label: "Facebook" },
          { value: "XIAOHONGSHU", label: "XHS" },
          { value: "LEMON8", label: "Lemon8" },
        ])
      }
    }

    fetchPlatforms()
  }, [client])

  const fetchCountries = async () => {
    try {
      const { data } = await client.query({
        query: GET_COUNTRIES,
        fetchPolicy: "no-cache",
      })

      // Map API data to DropdownMenu format
      const options = data.country_category.map((country: any) => ({
        value: country.code,
        label: country.name,
      }))

      const countryOptions = data.kol_profile
        .map((profile: any) => {
          let item: { value: string; label: string } = {
            value: profile.country_code,
            label: "",
          }
          for (const country of options) {
            if (country.value === profile.country_code) {
              item = { value: country.value, label: country.label }
              break
            }
          }

          // Add subitems for Malaysia
          if (item.value && item.value.toLowerCase() === "my") {
            return {
              ...item,
              items: malaysiaSubitems,
            }
          }

          return item
        })
        .filter(
          (item: { value: string; label: string; items?: Array<{ value: string; label: string }> }) =>
            item.label && item.label.trim() !== "",
        )

      setLocationItems(countryOptions)
      setCountryItems(options)
    } catch (error) {
      console.error("Error fetching countries:", error)
    }
  }

  const triggerRefreshing = () => {
    // Function to check if there are any loading indicators active
    const isLoadingIndicatorActive = () => {
      const loadingIndicators = document.querySelectorAll('[class*="RaLoadingIndicator-loadedLoading"]')
      return loadingIndicators.length > 0
    }

    // Wait for any existing API calls to complete first
    const waitForAPIsAndClick = () => {
      // Check if loading indicator is currently active (indicating API calls in progress)
      if (isLoadingIndicatorActive()) {
        setTimeout(waitForAPIsAndClick, 100) // Check again in 100ms
        return
      }

      // APIs are done, now click the refresh icon
      const refreshIcon = document.querySelector('[data-testid="RefreshIcon"]')
      if (refreshIcon) {
        const button = refreshIcon.closest("button")
        if (button) {
          button.click()
          return
        }
      }
    }

    // Start checking after a small delay to allow initial API calls to start
    setTimeout(waitForAPIsAndClick, 200)
  }

  //Fetch countries from API and convert for DropdownMenu
  useEffect(() => {
    fetchCountries()
  }, [client])

  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [])

  const exportToCSV = async () => {
    notify("Preparing export...", { type: "info" })

    try {
      // Get country data for mapping
      const allCountriesResponse = await client.query({
        query: GET_COUNTRIES,
        fetchPolicy: "no-cache",
      })
      const countries = allCountriesResponse.data.country_category

      // Apply the same filters as in App.tsx
      const platformHandle = filter.platform_handle || ""
      const platforms = filter.platform?.split(",")?.filter(Boolean) || []
      const categories = filter.category?.split(",")?.filter(Boolean) || []
      const states =
        filter.state
          ?.split(",")
          ?.filter(Boolean)
          ?.filter(Boolean)
          ?.map((state: string) => {
            const country = countries.find(
              (c: any) => c.code.toLowerCase() === state.toLowerCase() || c.name.toLowerCase() === state.toLowerCase(),
            )
            if (country) {
              return country.name
            }
            return state
          }) ?? []
      let genders = filter.gender?.split(",")?.filter(Boolean) || []

      // Add uppercase versions for gender matching (same as App.tsx)
      if (genders.includes("male")) {
        genders.push("Male")
      }
      if (genders.includes("female")) {
        genders.push("Female")
      }

      let tiers =
        filter.tier
          ?.split(",")
          ?.filter(Boolean)
          ?.map((tier: string) => {
            if (tier.toLowerCase() === "a-list") {
              return "A-list"
            }
            return tier.toUpperCase()
          }) || []

      let allKolData: any[] = []
      let currentPage = 1
      const pageSize = 9999
      let hasMoreData = true

      // Loop through all pages until no more data
      while (hasMoreData) {
        console.log(`Fetching export data page ${currentPage}...`)

        const result = await client.query({
          query: GET_KOLS,
          fetchPolicy: "no-cache",
          variables: {
            limit: pageSize,
            page: currentPage,
            username: platformHandle,
            category: categories.length > 0 ? categories : null,
            social_platform_code: platforms.length > 0 ? platforms : null,
            gender: genders.length > 0 ? genders : null,
            country: states.length > 0 ? states : null,
            social_platform_tier: tiers.length > 0 ? tiers : null,
          },
        })

        const pageData = result.data.getListKOLs.data

        if (pageData.length === 0) {
          hasMoreData = false
          break
        }

        // Apply the same post-processing as App.tsx
        let processedKols = pageData.map((kol: any) => {
          // Add country name mapping
          kol.country = countries.find((c: any) => c.code === kol.country_code)?.name || kol.country_code
          return kol
        })

        // Apply platform handle filtering (same logic as App.tsx)
        const findExactly = role === "campaign-manager" ? true : false
        let filteredKols: any[] = []

        for (let i = 0; i < processedKols.length; i++) {
          const kol = processedKols[i]
          if (findExactly) {
            // Campaign manager: exact match
            for (let j = 0; j < kol.kol_social_platforms.length; j++) {
              if (kol.kol_social_platforms[j].social_platform_handle === platformHandle) {
                filteredKols.push(kol)
                break
              }
            }
          } else {
            // Other roles: partial match or no filter
            if (platformHandle === "") {
              filteredKols.push(kol)
              continue
            }
            for (let j = 0; j < kol.kol_social_platforms.length; j++) {
              if (kol.kol_social_platforms[j].social_platform_handle.includes(platformHandle)) {
                filteredKols.push(kol)
                break
              }
            }
          }
        }

        allKolData = allKolData.concat(filteredKols)
        currentPage++

        // If we got less data than the page size, we've reached the end
        if (pageData.length < pageSize) {
          hasMoreData = false
        }

        // Update progress notification
        notify(`Fetched ${allKolData.length} records...`, { type: "info" })
      }

      if (allKolData.length === 0) {
        notify("No data matches your filters for export", { type: "warning" })
        return
      }

      console.log(`Total KOL records for export: ${allKolData.length}`)

      // Create CSV headers (same as before)
      const basicHeaders = [
        "No",
        "Full Name",
        "A-List",
        "State",
        "Race",
        "Country",
        "Gender",
        "Language",
        "Primary Category",
        "Secondary Category",
        "Co No",
        "Applied Brand",
        "Deliverables",
        "KOL Rate",
        "Currency",
        "Status",
        "Remarks",
      ]

      // Add platform-specific headers
      const platformHeaders = [
        "IG Handle",
        "IG Followers",
        "IG Tier",
        "TikTok Handle",
        "TikTok Followers",
        "TikTok Tier",
        "YouTube Channel",
        "YouTube Followers",
        "YouTube Tier",
        "XHS Handle",
        "XHS Followers",
        "XHS Tier",
        "Facebook Handle",
        "Facebook Followers",
        "Facebook Tier",
        "Lemon8 Handle",
        "Lemon8 Followers",
        "Lemon8 Tier",
      ]

      // Add pricing headers
      const pricingHeaders = [
        "IG Photo",
        "IG Multipost",
        "IG Reels",
        "IG Story",
        "IG Story Highlights",
        "TT Video",
        "TT Story",
        "XHS Multipost",
        "XHS Video",
        "L8 Video",
        "L8 Multipost",
        "YouTube Video",
        "YouTube Shorts",
        "FB Photo",
        "FB Multipost",
        "FB Video",
        "Livestream",
        "Photo Shoot",
        "Video Shoot",
        "Event Attendance",
        "Content Usage",
        "Link in bio",
        "Content creativity",
        "Posting Punctuality",
        "Responsiveness",
        "Overall Rating",
      ]

      const allHeaders = [...basicHeaders, ...platformHeaders, ...pricingHeaders]

      // Create CSV content
      let csvContent = allHeaders.join(",") + "\n"

      // Process all KOL data for CSV
      allKolData.forEach((kol) => {
        // Find platforms data
        const instagramPlatform = kol.kol_social_platforms.find(
          (platform: KolSocialPlatform) => platform.social_platform_code === "INSTAGRAM",
        )
        const tiktokPlatform = kol.kol_social_platforms.find(
          (platform: KolSocialPlatform) => platform.social_platform_code === "TIKTOK",
        )
        const youtubePlatform = kol.kol_social_platforms.find(
          (platform: KolSocialPlatform) => platform.social_platform_code === "YOUTUBE",
        )
        const xhsPlatform = kol.kol_social_platforms.find(
          (platform: KolSocialPlatform) => platform.social_platform_code === "XIAOHONGSHU",
        )
        const facebookPlatform = kol.kol_social_platforms.find(
          (platform: KolSocialPlatform) => platform.social_platform_code === "FACEBOOK",
        )
        const lemon8Platform = kol.kol_social_platforms.find(
          (platform: KolSocialPlatform) => platform.social_platform_code === "LEMON8",
        )

        const country = countryItems.find((c) => c.value === kol.country_code)?.label || kol.country_code

        // Create row data
        const rowData = [
          `${kol.name || "-"}`,
          `${kol.a_list === ALIST.YES ? "A-List" : "-"}`,
          `${kol.state || "-"}`,
          `${kol.race || "-"}`,
          `${country || "-"}`,
          `${kol.gender || "-"}`,
          `${kol.language || "-"}`.replaceAll(",", ";"),
          `${kol.primary_category || "-"}`.replaceAll(",", ";"),
          `${kol.secondary_category || "-"}`.replaceAll(",", ";"),
          `${kol.co_no || "-"}`,
          `${kol.brand || "-"}`.replaceAll(",", ";"),
          `${kol.deliverables || "-"}`,
          `${kol.kol_rate || "-"}`,
          `${getKolCurrency(kol) || "-"}`,
          `${kol.status || "-"}`,
          `${kol.remarks || "-"}`,

          // Platform data
          `${instagramPlatform?.social_platform_handle || "-"}`,
          `${instagramPlatform?.number_of_followers || "-"}`,
          `${instagramPlatform?.social_platform_tier || "-"}`,

          `${tiktokPlatform?.social_platform_handle || "-"}`,
          `${tiktokPlatform?.number_of_followers || "-"}`,
          `${tiktokPlatform?.social_platform_tier || "-"}`,

          `${youtubePlatform?.social_platform_handle || "-"}`,
          `${youtubePlatform?.number_of_followers || "-"}`,
          `${youtubePlatform?.social_platform_tier || "-"}`,

          `${xhsPlatform?.social_platform_handle || "-"}`,
          `${xhsPlatform?.number_of_followers || "-"}`,
          `${xhsPlatform?.social_platform_tier || "-"}`,

          `${facebookPlatform?.social_platform_handle || "-"}`,
          `${facebookPlatform?.number_of_followers || "-"}`,
          `${facebookPlatform?.social_platform_tier || "-"}`,

          `${lemon8Platform?.social_platform_handle || "-"}`,
          `${lemon8Platform?.number_of_followers || "-"}`,
          `${lemon8Platform?.social_platform_tier || "-"}`,

          // Pricing data
          `${kol.ig_photo || "-"}`,
          `${kol.ig_multipost || "-"}`,
          `${kol.ig_reels || "-"}`,
          `${kol.ig_story || "-"}`,
          `${kol.ig_story_highlights || "-"}`,
          `${kol.tt_video || "-"}`,
          `${kol.tt_story || "-"}`,
          `${kol.xhs_multipost || "-"}`,
          `${kol.xhs_video || "-"}`,
          `${kol.l8_video || "-"}`,
          `${kol.l8_multipost || "-"}`,
          `${kol.yt_video || "-"}`,
          `${kol.yt_shorts || "-"}`,
          `${kol.fb_photo || "-"}`,
          `${kol.fb_multipost || "-"}`,
          `${kol.fb_video || "-"}`,
          `${kol.livestream || "-"}`,
          `${kol.photo_shoot || "-"}`,
          `${kol.video_shoot || "-"}`,
          `${kol.event_attendance || "-"}`,
          `${kol.content_usage || "-"}`,
          `${kol.link_in_bio || "-"}`,
          `${kol.content_creativity || "-"}`,
          `${kol.posting_punctuality || "-"}`,
          `${kol.responsiveness || "-"}`,
          `${kol.overall_rating || "-"}`,
        ].map((field) => {
          //replace \n and \r with spaces
          if (typeof field === "string") {
            return `${field.replace(/[\n\r]+/g, " ")}`
          }
          return field
        })

        csvContent += rowData.join(", ") + "\n"
      })

      // Create download link
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.setAttribute("href", url)
      link.setAttribute("download", `kols_export_${new Date().toISOString().split("T")[0]}.csv`)
      document.body.appendChild(link)

      // Download file
      link.click()

      // Clean up
      document.body.removeChild(link)
      notify("Export completed successfully", { type: "success" })
    } catch (error) {
      console.error("Error exporting to CSV:", error)
      notify("Export failed. Please try again.", { type: "error" })
    }
  }

  // Helper function to check if any filter is active
  const hasActiveFilters = () => {
    return (
      filter.social_platform !== "" ||
      filter.category !== "" ||
      filter.state !== "" ||
      filter.gender !== "" ||
      filter.tier !== "" ||
      filter.platform !== ""
    )
  }

  return (
    <div
      className="scrollable-parent"
      style={{
        position: "relative",
        paddingTop: "10px",
        overflowX: "auto",
        width: "100%",
        maxWidth: "100%",
        whiteSpace: "nowrap",
        height: "100%",
        scrollBehavior: "smooth",
        scrollbarWidth: "thin",
        scrollbarColor: "green",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <p style={{ position: "fixed", top: actionTopMargin, right: searchBarPosition, zIndex: 1000 }}>
        <div style={{ position: "relative", display: "inline-block" }}>
          <input
            type="text"
            style={{
              height: "38px",
              width: "300px",
              backgroundColor: "rgb(241, 241, 241)",
              borderRadius: "15px",
              border: "1px solid rgb(241, 241, 241)",
              padding: "10px",
              marginTop: "5px",
              paddingRight: "30px",
            }}
            value={inputValue}
            placeholder="Input kol's platform handle"
            onChange={(event) => {
              if (event.target.value === "") {
                const newFilter = {
                  social_platform: filter.social_platform,
                  platform_handle: event.target.value,
                  category: filter.category,
                  state: filter.state,
                  gender: filter.gender,
                  tier: filter.tier,
                  platform: filter.platform,
                }
                setFilter(newFilter)
              }
              setInputValue(event.target.value)
            }}
          />
          <SearchIcon
            style={{
              position: "absolute",
              height: "20px",
              width: "20px",
              top: "10px",
              marginTop: "5px",
              right: "10px",
            }}
          />
        </div>
        <div ref={suggestionListRef} style={{ position: "fixed", maxWidth: "500px" }}>
          {fetchSugguestion.length > 0 &&
            SugguestionList({
              data: suggestions,
              onItemClick: (item: SugguestionItem) => {
                setInputValue(item.name)
                getKolDetails(item)
                setSuggestions([])
              },
            })}
        </div>
      </p>

      <button
        style={{
          position: "fixed",
          top: actionTopMargin,
          height: "38px",
          backgroundColor: "#6750A4",
          borderRadius: "15px",
          width: addKolButtonWidth,
          paddingLeft: "20px",
          paddingRight: "20px",
          fontSize: "13px",
          color: "white",
          justifyContent: "center",
          border: "1px solid rgb(241, 241, 241)",
          marginTop: "20px",
          right: addKolButtonPosition,
          zIndex: 1000,
          cursor: "pointer",
          alignItems: "center",
        }}
        onClick={() => {
          onRowClick({})
        }}
      >
        {" "}
        Add KOL{" "}
      </button>

      {!showPopup && (
        <>
          {role === "general-manager" || role === "system-admin" ? (
            <button
              style={{
                position: "fixed", // Change from relative to fixed
                top: actionTopMargin + 10, // Match search bar's top position
                left: "260px", // Position from left side
                height: "38px",
                backgroundColor: "#6750A4",
                borderRadius: "15px",
                width: exportButtonWidth,
                paddingLeft: "20px",
                paddingRight: "20px",
                fontSize: "13px",
                color: "white",
                justifyContent: "center",
                border: "1px solid rgb(241, 241, 241)",
                marginTop: "5px", // Add same marginTop as search input
                cursor: "pointer",
                zIndex: 1000,
                display: "flex", // Add flex display
                alignItems: "center",
              }}
              onClick={() => exportToCSV()}
            >
              Export
            </button>
          ) : (
            <div
              style={{
                position: "relative",
                height: "38px",
                width: exportButtonWidth,
                marginBottom: "-20px",
                marginLeft: "0",
                opacity: 0,
                visibility: "hidden",
              }}
              aria-hidden="true"
            />
          )}
          <div
            className="scrollable-container"
            style={{
              overflowX: "auto",
              width: "100%",
              maxWidth: "100%",
              scrollbarWidth: "thin",
              msOverflowStyle: "scrollbar",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <div
              style={{
                position: "fixed",
                top: actionTopMargin,
                left: "240px", // Align with sidebar width
                right: 0,
                height: "120px", // Enough height to cover export button and filter bar
                backgroundColor: "#f9f9fa",
                zIndex: 800, // Below filter bar (900) but above list content
                pointerEvents: "none", // Allow clicks to pass through to elements below
              }}
            />

            <div
              style={{
                overflowX: "auto",
                marginTop: "-25px",
                minWidth: "2000px",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "15px",
                  borderRadius: "4px",
                  marginBottom: "0px",
                  marginTop: "0", // Remove top margin
                  width: "calc(100vw - 230px)",
                  maxWidth: "calc(100vw - 230px)",
                  position: "fixed",
                  top: actionTopMargin + 60, // Position below search bar and export button (with buffer)
                  left: "240px", // Align with sidebar
                  flexWrap: "wrap",
                  zIndex: 900, // Lower z-index than buttons
                  boxSizing: "border-box",
                }}
              >
                {/* Location Dropdown */}
                <div style={{ flex: "0 0 16%", marginRight: "20px" }}>
                  <DropdownMenu
                    placeholder="Location"
                    items={memoizedLocationItems}
                    onChange={handleLocationChange}
                    value={filter.state.split(",")}
                    multiple={true}
                    type="locations"
                  />
                </div>

                {/* Gender Dropdown */}
                <div style={{ flex: "0 0 16%", marginRight: "20px" }}>
                  <DropdownMenu
                    placeholder="Gender"
                    items={memoizedGenderItems}
                    onChange={handleGenderChange}
                    value={filter.gender.split(",")}
                    type="genders"
                  />
                </div>

                {/* Follower Range Dropdown */}
                <div style={{ flex: "0 0 16%", marginRight: "20px" }}>
                  <DropdownMenu
                    placeholder="Follower Range"
                    items={memoizedTierItems}
                    onChange={handleTierChange}
                    value={filter.tier.split(",")}
                    type="follower ranges"
                  />
                </div>

                {/* Platform Dropdown */}
                <div style={{ flex: "0 0 16%", marginRight: "20px" }}>
                  <DropdownMenu
                    placeholder="Platform"
                    items={memoizedPlatformItems}
                    onChange={handlePlatformChange}
                    value={filter.platform.split(",")}
                    type="platforms"
                  />
                </div>

                {/* Category Dropdown */}
                <div style={{ flex: "0 0 16%", marginRight: "20px" }}>
                  <DropdownMenu
                    placeholder="Category"
                    items={memoizedCategoryItems}
                    onChange={handleCategoryChange}
                    value={filter.category.split(",")}
                    type="categories"
                  />
                </div>

                {/* Reset Button */}
                <div style={{ flex: "0 0 13%" }}>
                  <button
                    style={{
                      width: "100%",
                      backgroundColor: "#F4F4F4",
                      border: hasActiveFilters() ? "2px solid #6750A4" : "2px solid #C4C4C4", // Change border color based on active filters
                      borderRadius: "20px",
                      padding: "10px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      minHeight: "40px",
                      color: hasActiveFilters() ? "#6750A4" : "#C4C4C4", // Also change text color
                    }}
                    onClick={() => {
                      // Reset all filters
                      setFilter({
                        social_platform: "",
                        platform_handle: "",
                        category: "",
                        state: "",
                        gender: "",
                        tier: "",
                        platform: "",
                      })
                      setInputValue("")
                    }}
                  >
                    Reset Filters
                  </button>
                </div>
              </div>

              <List
                style={{ marginTop: "110px", marginLeft: "10px" }}
                {...props}
                pagination={<CustomPagination />}
                sx={{
                  marginTop: "0",
                  "& .RaList-main": {
                    marginTop: "0",
                    paddingTop: "0",
                  },
                  "& .MuiPaper-root": {
                    marginTop: "0",
                    paddingTop: "0",
                  },
                }}
                sort={{ field: "updated_at", order: "DESC" }}
                filter={filter}
                exporter={false}
                empty={
                  <div
                    style={{
                      width: "100vw",
                      height: "100vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "fixed",
                    }}
                  ></div>
                }
              >
                <div style={{ overflowX: "auto", width: "100%" }}>
                  <Datagrid
                    rowClick={(id: Identifier, resource: string, record) => {
                      onRowClick(record)
                      return ""
                    }}
                    bulkActionButtons={false}
                    rowStyle={(record, index) => ({
                      backgroundColor: index % 2 != 0 ? "#ffffff" : "#f5f5f5",
                    })}
                    sx={{
                      "& .MuiTable-root": {
                        tableLayout: "auto",
                        minWidth: "2400px",
                      },
                      "& .MuiTableCell-root": {
                        whiteSpace: "nowrap",
                      },
                      "& .MuiTableCell-head": {
                        fontWeight: "bold",
                        fontSize: "14px",
                      },
                    }}
                  >
                    <FunctionField
                      label="No"
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {record?.no || ""}
                        </div>
                      )}
                    />
                    <FunctionField
                      label="Full Name"
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {record?.name || ""}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>A-List</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.a_list === ALIST.YES ? "A-List" : null}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label="IG Handle"
                      render={(record: any) => {
                        const instagramPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "INSTAGRAM",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {instagramPlatform ? instagramPlatform.social_platform_handle : <span>---</span>}
                          </div>
                        )
                      }}
                    />
                    <FunctionField
                      label="IG Followers"
                      render={(record: any) => {
                        const instagramPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "INSTAGRAM",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {instagramPlatform ? (
                              <span>{formatNumber(instagramPlatform.number_of_followers)}</span>
                            ) : (
                              <span>0</span>
                            )}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="IG Tier"
                      render={(record: any) => {
                        const instagramPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "INSTAGRAM",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {instagramPlatform ? instagramPlatform.social_platform_tier : <span>---</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="TikTok Handle"
                      render={(record: any) => {
                        const tiktokPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "TIKTOK",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {tiktokPlatform ? tiktokPlatform.social_platform_handle : <span>---</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="TikTok Followers"
                      render={(record: any) => {
                        const tiktokPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "TIKTOK",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {tiktokPlatform ? <span>{formatNumber(tiktokPlatform.number_of_followers)}</span> : <span>0</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="TikTok Tier"
                      render={(record: any) => {
                        const instagramPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "TIKTOK",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {instagramPlatform ? instagramPlatform.social_platform_tier : <span>---</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="YouTube Channel"
                      render={(record: any) => {
                        const youtubePlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "YOUTUBE",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {youtubePlatform ? youtubePlatform.social_platform_handle : <span>---</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="YouTube Followers"
                      render={(record: any) => {
                        const youtubePlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "YOUTUBE",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {youtubePlatform ? <span>{formatNumber(youtubePlatform.number_of_followers)}</span> : <span>0</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="YouTube Tier"
                      render={(record: any) => {
                        const instagramPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "YOUTUBE",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {instagramPlatform ? instagramPlatform.social_platform_tier : <span>---</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="XHS Handle"
                      render={(record: any) => {
                        const xhsPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "XIAOHONGSHU",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {xhsPlatform ? xhsPlatform.social_platform_handle : <span>---</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="XHS Followers"
                      render={(record: any) => {
                        const xhsPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "XIAOHONGSHU",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {xhsPlatform ? <span>{formatNumber(xhsPlatform.number_of_followers)}</span> : <span>0</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="XHS Tier"
                      render={(record: any) => {
                        const instagramPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "XIAOHONGSHU",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {instagramPlatform ? instagramPlatform.social_platform_tier : <span>---</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="Facebook Handle"
                      render={(record: any) => {
                        const facebookPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "FACEBOOK",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {facebookPlatform ? facebookPlatform.social_platform_handle : <span>---</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="Facebook Followers"
                      render={(record: any) => {
                        const facebookPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "FACEBOOK",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {facebookPlatform ? (
                              <span>{formatNumber(facebookPlatform.number_of_followers)}</span>
                            ) : (
                              <span>0</span>
                            )}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="Facebook Tier"
                      render={(record: any) => {
                        const instagramPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "FACEBOOK",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {instagramPlatform ? instagramPlatform.social_platform_tier : <span>---</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="Lemon8 Handle"
                      render={(record: any) => {
                        const lemon8Platform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "LEMON8",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {lemon8Platform ? lemon8Platform.social_platform_handle : <span>---</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="Lemon8 Followers"
                      render={(record: any) => {
                        const lemon8Platform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "LEMON8",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {lemon8Platform ? <span>{formatNumber(lemon8Platform.number_of_followers)}</span> : <span>0</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label="Lemon8 Tier"
                      render={(record: any) => {
                        const instagramPlatform = record.kol_social_platforms.find(
                          (platform: any) => platform.social_platform_code === "LEMON8",
                        )
                        return (
                          <div
                            style={{ whiteSpace: "nowrap", position: "sticky", minWidth: "100px", left: 0 }}
                            onClick={() => {
                              onRowClick(record)
                            }}
                          >
                            {instagramPlatform ? instagramPlatform.social_platform_tier : <span>---</span>}
                          </div>
                        )
                      }}
                    />

                    <FunctionField
                      label={<span>Contact</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.contact}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Email</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.email}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Alternative Email</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.alternative_email}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Address</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.address}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>State</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.state}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Race</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.race}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Country</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.country}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Gender</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.gender}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Language</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.language}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Primary category</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.primary_category}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Secondary category</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.secondary_category}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Co No</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.co_no}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Applied Brand</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.brand}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label="Deliverables"
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "200px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.deliverables}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>KOL Rate</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.kol_rate)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Currency</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{getKolCurrency(record)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>IG Photo</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.ig_photo)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>IG Multipost</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.ig_multipost)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>IG Reels</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.ig_reels)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>IG Story</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.ig_story)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>TT Video</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.tt_video)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>TT Story</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.tt_story)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>XHS Multipost</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.xhs_multipost)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>XHS Video</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.xhs_video)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>L8 Video</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.l8_video)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>L8 Multipost</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.l8_multipost)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>YouTube Video</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.yt_video)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>YouTube Shorts</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.yt_shorts)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>FB Photo</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.fb_photo)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>FB Multipost</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.fb_multipost)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>FB Video</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.fb_video)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Livestream</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.livestream)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Photo Shoot</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.photo_shoot)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Video Shoot</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.video_shoot)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Event Attendance</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.event_attendance)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Content Usage</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.content_usage)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>IG Story Highlights </span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.ig_story_highlights)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Link in bio</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.link_in_bio}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Content creativity</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.content_creativity)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Posting Punctuality</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.posting_punctuality)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Responsiveness</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.responsiveness)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Overall Rating</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{formatNumber(record?.overall_rating)}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Status</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.status}</span>}
                        </div>
                      )}
                    />
                    <FunctionField
                      label={<span>Remarks</span>}
                      render={(record: any) => (
                        <div
                          style={{
                            whiteSpace: "nowrap",
                            position: "sticky",
                            minWidth: "100px",
                            left: 0,
                          }}
                          onClick={() => {
                            onRowClick(record)
                          }}
                        >
                          {<span>{record?.remarks}</span>}
                        </div>
                      )}
                    />
                  </Datagrid>
                </div>
              </List>
            </div>
          </div>
        </>
      )}
      <AddKolDialog
        open={showPopup}
        kolData={selectedKol}
        onClose={() => {
          setShowPopup(false)
          setSelectedKol({})
        }}
        onSave={(data) => {
          setShowPopup(false)
          setSelectedKol({})
          const kol_profile_id = data.id

          const id = kol_profile_id ?? uuid()
          const newKolData = {
            id: id,
            name: data.name,
            contact: data.contact,
            email: data.email,
            alternative_email: data.alternative_email,
            address: data.address,
            state: data.state,
            race: data.race,
            gender: data.gender,
            language: data.language,
            livestream: data.livestream,
            content_usage: data.content_usage,
            primary_category: data.primary_category,
            secondary_category: data.secondary_category,
            co_no: data.co_no,
            brand: data.brand,
            deliverables: data.deliverables,
            kol_rate: data.kol_rate,
            status: data.status,
            content_creativity: data.content_creativity,
            posting_punctuality: data.posting_punctuality,
            responsiveness: data.responsiveness,
            remarks: data.remarks,
            ig_photo: data.ig_photo,
            ig_story: data.ig_story,
            ig_reels: data.ig_reels,
            ig_multipost: data.ig_multipost,
            tt_video: data.tt_video,
            tt_story: data.tt_story,
            xhs_multipost: data.xhs_multipost,
            xhs_video: data.xhs_video,
            live_stream: data.live_stream,
            photo_shoot: data.photo_shoot,
            video_shoot: data.video_shoot,
            event_attendance: data.event_attendance,
            ig_story_highlights: data.ig_story_highlights,
            link_in_bio: data.link_in_bio,
            l8_video: data.l8_video,
            l8_multipost: data.l8_multipost,
            yt_video: data.yt_video,
            yt_shorts: data.yt_shorts,
            fb_photo: data.fb_photo,
            fb_video: data.fb_video,
            fb_multipost: data.fb_multipost,
            overall_rating: data.overall_rating,
            currency: data.currency,
            a_list: data.a_list,
            country_code: data.country_code,
          }

          const performKolOperation = new Promise((resolve, reject) => {
            if (kol_profile_id) {
              updateKol({
                variables: {
                  kol: newKolData,
                  id: id,
                },
              })
                .then((res) => {
                  client
                    .mutate({
                      mutation: DELETE_KOL_SOCIAL_PLATFORM,
                      variables: {
                        kol_profile_id: id,
                      },
                    })
                    .then((res) => {
                      if (data.kol_social_platforms) {
                        const platforms = data.kol_social_platforms.map((platform: any) => {
                          return {
                            kol_profile_id: id,
                            social_platform_code: platform.social_platform_code,
                            social_platform_handle: platform.social_platform_handle,
                            number_of_followers: platform.number_of_followers,
                            social_platform_tier: platform.social_platform_tier,
                          }
                        })

                        client
                          .mutate({
                            mutation: INSERT_KOL_SOCIAL_PLATFORMS,
                            variables: {
                              kolSocialPlatform: platforms,
                            },
                          })
                          .then((res) => {
                            triggerRefreshing()
                            fetchCountries()
                            notify(`KOL is updated successfully`, { type: "success" })
                          })
                          .catch((err) => {
                            console.error("err inserting: ", err)
                            notify(`An error occured, please try again later `, { type: "error" })
                          })
                      }
                    })
                    .catch((err) => {
                      console.error("err deleting: ", err)
                      notify(`An error occured, please try again later `, { type: "error" })
                    })
                })
                .catch((err) => {
                  console.error("err saving: ", err)
                  notify(`An error occured, please try again later `, { type: "error" })
                })
            } else {
              insertKol({
                variables: {
                  kol: newKolData,
                },
              })
                .then((res) => {
                  if (role === "general-manager") {
                    client
                      .mutate({
                        mutation: DELETE_KOL_SOCIAL_PLATFORM,
                        variables: {
                          kol_profile_id: id,
                        },
                      })
                      .then((res) => {
                        if (data.kol_social_platforms) {
                          const platforms = data.kol_social_platforms.map((platform: any) => {
                            return {
                              kol_profile_id: id,
                              social_platform_code: platform.social_platform_code,
                              social_platform_handle: platform.social_platform_handle,
                              number_of_followers: platform.number_of_followers,
                              social_platform_tier: platform.social_platform_tier,
                            }
                          })

                          client
                            .mutate({
                              mutation: INSERT_KOL_SOCIAL_PLATFORMS,
                              variables: {
                                kolSocialPlatform: platforms,
                              },
                            })
                            .then((res) => {
                              //refresh()
                              triggerRefreshing()
                              //fetchCountries()
                              notify(`KOL is added successfully`, { type: "success" })
                            })
                            .catch((err) => {
                              console.error("err inserting: ", err)
                              notify(`An error occured, please try again later `, { type: "error" })
                            })
                        } else {
                          triggerRefreshing()
                          //fetchCountries()
                          notify(`KOL is added successfully`, { type: "success" })
                        }
                      })
                      .catch((err) => {
                        console.error("err deleting: ", err)
                        notify(`An error occured, please try again later `, { type: "error" })
                      })
                  } else {
                    if (data.kol_social_platforms) {
                      const platforms = data.kol_social_platforms.map((platform: any) => {
                        return {
                          kol_profile_id: id,
                          social_platform_code: platform.social_platform_code,
                          social_platform_handle: platform.social_platform_handle,
                          number_of_followers: platform.number_of_followers,
                          social_platform_tier: platform.social_platform_tier,
                        }
                      })

                      client
                        .mutate({
                          mutation: INSERT_KOL_SOCIAL_PLATFORMS,
                          variables: {
                            kolSocialPlatform: platforms,
                          },
                        })
                        .then((res) => {
                          triggerRefreshing()
                          //fetchCountries()
                          notify(`KOL is added successfully`, { type: "success" })
                        })
                        .catch((err) => {
                          console.error("err inserting: ", err)
                          notify(`An error occured, please try again later `, { type: "error" })
                        })
                    } else {
                      triggerRefreshing()
                      //fetchCountries()
                      notify(`KOL is added successfully`, { type: "success" })
                    }
                  }
                })
                .catch((err) => {
                  console.error("err saving: ", err)
                  notify(`An error occured, please try again later `, { type: "error" })
                })
            }
          })
        }}
        onDelete={(data) => {
          const kol_profile_id = selectedKol.id
          setShowPopup(false)
          setSelectedKol({})
          client
            .mutate({
              mutation: DELETE_KOL_SOCIAL_PLATFORM,
              variables: {
                kol_profile_id: kol_profile_id,
              },
            })
            .then((res) => {
              deleteKol({
                variables: {
                  kol_profile_id: kol_profile_id,
                },
              })
                .then((res) => {
                  //refresh()
                  triggerRefreshing()
                  fetchCountries()
                  notify(`KOL is deleted successfully`, { type: "success" })
                })
                .catch((err) => {
                  console.error("deleteKol_err", err)
                  notify(`An error occured, please try again later `, { type: "error" })
                })
            })
            .catch((err) => {
              console.error("deleteKol_err", err)
              notify(`An error occured, please try again later `, { type: "error" })
            })
        }}
      />
    </div>
  )
}

function getKolCurrency(kol: any) {
  if (kol.currency === "" || !kol.currency) {
    return kol.currency
  }
  const paths = kol.currency.split(" - ")
  if (paths.length > 1) {
    return paths[1]
  }
}

function useDebounce(value: string, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

function tierOfKOL(follower: any) {
  if (follower >= 1000000) return "Elite"
  if (follower >= 500000) return "Mega"
  if (follower >= 100000) return "Macro"
  if (follower >= 50000) return "Mid B"
  if (follower >= 15000) return "Mid C"
  if (follower >= 5000) return "Micro"
  if (follower >= 1000) return "Nano"
  return "KOC"
}
